export default function StatStrip({ stats, className = '' }) {
  return (
    <div
      className={`grid rounded-card border border-border-default overflow-hidden ${className}`}
      style={{ gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))` }}
    >
      {stats.map(({ label, value }, i) => (
        <div
          key={i}
          className={`bg-surface-card px-3 py-2.5 ${i > 0 ? 'border-l border-border-default' : ''}`}
        >
          <div className="text-label uppercase text-ink-muted">{label}</div>
          <div className="text-section-title font-mono tabular-nums text-ink mt-0.5">{value}</div>
        </div>
      ))}
    </div>
  );
}
